import EmObject, { defineProperty, computed } from '@ember/object';
import { notEmpty } from '@ember/object/computed';
import { differentFilters } from 'cio/utils/filters';
import { isNone } from '@ember/utils';

export default EmObject.extend({
  type: '',

  // These are set in the init hook, but we don't define them right on the
  // object because TS files extending from this file complain about not being
  // able to assign to the "null" type.
  // Keeping the lines commented to make it more obvious that these properties
  // do exist though
  // actionType: null,
  // action: null,

  _isDirty: false,
  isDirty: null, // defined in init

  init() {
    this._super(...arguments);

    if (isNone(this.action)) {
      this.set('action', null);
    }

    if (isNone(this.actionType)) {
      this.set('actionType', null);
    }

    if (isNone(this._editableProperties)) {
      this.set('_editableProperties', []);
    }

    if (isNone(this._dirtyDependencies)) {
      this.set('_dirtyDependencies', []);
    }

    this.prepareForEdit();

    this.set('actionType', this.action.type);

    if (isNone(this.isDirty)) {
      let dirtyDependentKeys = this._editableProperties.concat(this._dirtyDependencies);
      defineProperty(
        this,
        'isDirty',
        computed(...dirtyDependentKeys, '_isDirty', function () {
          let { action } = this;

          let primitiveProperties = this._editableProperties.filter((property) => property !== 'preconditions');

          return (
            this._isDirty ||
            differentFilters(action.preconditions, this.preconditions) ||
            primitiveProperties.any((p) => this[p] !== action[p])
          );
        }),
      );
    }
  },

  prepareForEdit() {
    this.setProperties(this.action.getProperties(...this._editableProperties));
  },

  prepareForSave() {
    let { action } = this;
    action.setProperties(this.getProperties(...this._editableProperties));

    return action;
  },

  errorString: computed('errors', function () {
    if (isNone(this.errors)) {
      return null;
    }

    let strings = [];

    Object.values(this.errors).forEach((errorsArray) => strings.push(...errorsArray));

    return strings.join('. ');
  }),
  hasErrors: notEmpty('errors'),
});
